
const state = () => ({
  /**
   * This is the message shown to the user.
   * @type [String, Array]
   */
  message: '',

  /**
   * This is the alert type that determines the icon and the color.
   * @type String
   */
  type: 'info',

  /**
   * This is the component used to render the alert.
   * @type String
   */
  component: 'dialog',

  /**
   * Determine the visibility of the alert.
   * @type Boolean
   */
  show: false,
})

const getters = {}

const mutations = {
  setMessage (state, v) {
    state.message = v
  },
  setType (state, v) {
    state.type = v
  },
  setComponent (state, v) {
    state.component = v
  },
  show (state) {
    state.show = true
  },
  hide (state) {
    state.show = false
  },
}

const actions = {
  showError ({ commit }, message) {
    commit('setMessage', message ?? 'Error')
    commit('setType', 'error')
    commit('setComponent', 'dialog')
    commit('show')
  },
  showWarning ({ commit }, message) {
    commit('setMessage', message ?? 'Warning')
    commit('setType', 'warning')
    commit('setComponent', 'dialog')
    commit('show')
  },
  showInfo ({ commit }, message) {
    commit('setMessage', message ?? 'Info')
    commit('setType', 'info')
    commit('setComponent', 'dialog')
    commit('show')
  },
  showSuccess ({ commit }, message) {
    commit('setMessage', message ?? 'Success')
    commit('setType', 'success')
    commit('setComponent', 'dialog')
    commit('show')
  },
  snackInfo ({ commit }, message) {
    commit('setMessage', message ?? 'Info')
    commit('setType', 'info')
    commit('setComponent', 'snackbar')
    commit('show')
  },
  snackSuccess ({ commit }, message) {
    commit('setMessage', message ?? 'Success')
    commit('setType', 'success')
    commit('setComponent', 'snackbar')
    commit('show')
  },
  hide ({ commit }) {
    commit('hide')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
